import { Component } from "@angular/core";
import { CoverStaticRevisionComponent } from "../../UI/cover-static-revision/cover-static-revision.component";

import { StudentRevisionNoteComponent } from "../../../shared/business/student-revision-note/student-revision-note.component";
import { StaticCardNoteComponent } from "../../../shared/business/static-card-note/static-card-note.component";
import { ExploreToolsComponent } from "../../../shared/UI/explore-tools/explore-tools.component";

@Component({
  selector: "app-static-revision-notes",
  imports: [
    CoverStaticRevisionComponent,
    StudentRevisionNoteComponent,
    StaticCardNoteComponent,
    //  BrowseSubjectsComponent,
    ExploreToolsComponent,
  ],
  templateUrl: "./static-revision-notes.component.html",
  styleUrl: "./static-revision-notes.component.css",
})
export class StaticRevisionNotesComponent {}
